import Dashboard from './dashboard';
import ProfilRoutes from './profil';
import FormationRoutes from './formation';
import FormationSessionRoutes from './formation-session';
import CompetenceRoute from './competence';
import HabilitationRoute from './habilitation';

export default [
  ...Dashboard,
  ...ProfilRoutes,
  ...FormationRoutes,
  ...FormationSessionRoutes,
  ...CompetenceRoute,
  ...HabilitationRoute,
];
